export default "__VITE_ASSET__964ac496__"